export default "__VITE_ASSET__obSxIXt2__"